import { api } from "./client";

export async function generateInviteLink({ game, poolId, seasonId }) {
  const resp = await api.post("/invites/generate", {
    game,
    pool_id: poolId,
    season_id: seasonId,
  });
  return resp.data; // { token, link }
}

export async function getInviteInfo(token) {
  const resp = await api.get(`/invites/${token}`);
  return resp.data; // { game, game_label, pool_id, pool_name, season_id, redirect_path }
}

export async function joinViaInvite(token, { email } = {}) {
  const resp = await api.post(`/invites/${token}/join`, { email: email || null });
  return resp.data; // { status, redirect_path, access_token?, token_type?, user? }
}
